import React, { useState } from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { WhatYouGetSection } from '../components/sales/WhatYouGetSection';
import { WhyNotWorkedSection } from '../components/sales/WhyNotWorkedSection';
import { MethodSection } from '../components/sales/MethodSection';
import { FirstWeekSection } from '../components/sales/FirstWeekSection';
import { WeekByWeekSection } from '../components/sales/WeekByWeekSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { PreviewSection } from '../components/sales/PreviewSection';
import { AuthorSection } from '../components/sales/AuthorSection';
import { TestimonialsSection } from '../components/sales/TestimonialsSection';
import { FAQSection } from '../components/sales/FAQSection';
import { OfferStackSection } from '../components/sales/OfferStackSection';
import { GuaranteeSection } from '../components/sales/GuaranteeSection';
import { FinalCTASection } from '../components/sales/FinalCTASection';
import { StickyCTA } from '../components/sales/StickyCTA';
import { PurchasePopup } from '../components/sales/PurchasePopup';
import { X } from 'lucide-react';
type LegalModal = 'terminos' | 'privacidad' | 'cookies' | 'reembolsos' | null;
const legalContent: Record<string, {
  title: string;
  body: string;
}> = {
  terminos: {
    title: 'Términos y Condiciones',
    body: `Última actualización: Enero 2026

1. ACEPTACIÓN DE TÉRMINOS
Al acceder a este sitio web y realizar una compra, usted acepta estos Términos y Condiciones en su totalidad. Si no está de acuerdo con alguno de estos términos, le pedimos que no utilice este sitio.

2. PRODUCTO DIGITAL
"Celular bajo control, hogar en paz" es un producto digital (ebook en formato PDF) que se entrega mediante descarga electrónica inmediata después de la confirmación del pago. No se envían productos físicos.

3. USO PERSONAL
La guía es para uso personal y familiar del comprador. Queda prohibida su reproducción, distribución, reventa o compartición pública sin autorización expresa por escrito.

4. PROPIEDAD INTELECTUAL
Todo el contenido de esta guía, incluyendo textos, diseños, plantillas y materiales complementarios, está protegido por derechos de autor y es propiedad de Conexión Primero.

5. PRECIO Y PAGO
El precio del producto es de $6.36 USD. El pago se procesa de forma segura a través de Hotmart, una plataforma de pagos reconocida internacionalmente. No almacenamos datos de tarjetas de crédito.

6. LIMITACIÓN DE RESPONSABILIDAD
Esta guía ofrece información educativa y estrategias prácticas. No sustituye el consejo profesional de un psicólogo, terapeuta familiar o profesional de salud mental. Los resultados pueden variar según cada familia.

7. MODIFICACIONES
Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios serán efectivos desde su publicación en este sitio.

8. CONTACTO
Para cualquier consulta sobre estos términos, puede contactarnos a través de nuestro correo electrónico de soporte.`
  },
  privacidad: {
    title: 'Política de Privacidad',
    body: `Última actualización: Enero 2026

1. INFORMACIÓN QUE RECOPILAMOS
Recopilamos únicamente la información necesaria para procesar su compra:
• Nombre completo
• Dirección de correo electrónico
• Información de pago (procesada por Hotmart, no almacenada por nosotros)

2. USO DE LA INFORMACIÓN
Su información personal se utiliza exclusivamente para:
• Procesar y entregar su compra
• Enviar el enlace de descarga del producto
• Comunicarnos con usted sobre su pedido
• Procesar solicitudes de reembolso si aplica

3. PROTECCIÓN DE DATOS
Implementamos medidas de seguridad técnicas y organizativas para proteger su información personal contra acceso no autorizado, alteración o destrucción.

4. COMPARTICIÓN CON TERCEROS
No vendemos, alquilamos ni compartimos su información personal con terceros, excepto:
• Hotmart: para procesar pagos de forma segura
• Proveedores de correo electrónico: para entregar su producto

5. COOKIES
Utilizamos cookies esenciales para el funcionamiento del sitio y cookies analíticas para mejorar la experiencia del usuario. Consulte nuestra Política de Cookies para más detalles.

6. SUS DERECHOS
Usted tiene derecho a:
• Acceder a sus datos personales
• Solicitar la corrección de datos inexactos
• Solicitar la eliminación de sus datos
• Retirar su consentimiento en cualquier momento

7. CONTACTO
Para ejercer sus derechos o realizar consultas sobre privacidad, contáctenos a través de nuestro correo electrónico de soporte.`
  },
  cookies: {
    title: 'Política de Cookies',
    body: `Última actualización: Enero 2026

1. ¿QUÉ SON LAS COOKIES?
Las cookies son pequeños archivos de texto que se almacenan en su dispositivo cuando visita nuestro sitio web. Nos ayudan a mejorar su experiencia de navegación.

2. COOKIES QUE UTILIZAMOS

Cookies Esenciales:
• Necesarias para el funcionamiento básico del sitio
• No pueden ser desactivadas
• No recopilan información personal identificable

Cookies Analíticas:
• Nos ayudan a entender cómo los visitantes interactúan con el sitio
• Recopilan información de forma anónima
• Utilizamos Meta Pixel para medir la efectividad de nuestros anuncios

Cookies de Marketing:
• Utilizadas para mostrar anuncios relevantes
• Pueden ser compartidas con plataformas publicitarias (Meta/Facebook)

3. CONTROL DE COOKIES
Puede controlar y eliminar cookies a través de la configuración de su navegador. Tenga en cuenta que desactivar ciertas cookies puede afectar la funcionalidad del sitio.

4. COOKIES DE TERCEROS
Nuestro sitio puede contener cookies de terceros como:
• Meta (Facebook) Pixel: para análisis y publicidad
• Hotmart: para procesamiento de pagos

5. ACTUALIZACIONES
Esta política puede actualizarse periódicamente. Le recomendamos revisarla regularmente.`
  },
  reembolsos: {
    title: 'Política de Reembolsos y Devoluciones',
    body: `Última actualización: Enero 2026

1. GARANTÍA DE SATISFACCIÓN DE 7 DÍAS
Ofrecemos una garantía incondicional de 7 días naturales a partir de la fecha de compra. Si por cualquier motivo no estás satisfecha con la guía, te devolvemos el 100% de tu dinero.

2. CÓMO SOLICITAR UN REEMBOLSO
Para solicitar un reembolso:
• Envía un correo electrónico a nuestro equipo de soporte dentro de los 7 días posteriores a tu compra
• Incluye tu nombre completo y el correo electrónico utilizado para la compra
• No necesitas dar explicaciones ni justificaciones

3. PROCESO DE REEMBOLSO
• Tu solicitud será procesada en un plazo máximo de 48 horas hábiles
• El reembolso se realizará a través del mismo método de pago utilizado para la compra
• El tiempo de acreditación depende de tu banco o entidad financiera (generalmente 5-10 días hábiles)

4. CONDICIONES
• El reembolso aplica únicamente dentro de los 7 días naturales posteriores a la compra
• Solo se permite un reembolso por cliente
• Después del reembolso, perderás acceso al material descargado

5. NATURALEZA DEL PRODUCTO DIGITAL
Al ser un producto digital de descarga inmediata, no es posible "devolver" el producto. Sin embargo, honramos nuestra garantía de 7 días sin condiciones.

6. CONTACTO
Para solicitudes de reembolso o consultas, contáctanos a través de nuestro correo electrónico de soporte. Responderemos en un máximo de 24 horas.`
  }
};
export function SalesPage() {
  const [activeModal, setActiveModal] = useState<LegalModal>(null);
  return <div className="min-h-screen bg-primary font-body text-text-primary selection:bg-coral/20 selection:text-text-primary" data-id="element-266">
      <main data-id="element-267">
        <HeroSection data-id="element-268" />
        <ProblemSection data-id="element-269" />
        <WhatYouGetSection data-id="element-270" />
        <WhyNotWorkedSection data-id="element-271" />
        <MethodSection data-id="element-272" />
        <FirstWeekSection data-id="element-273" />
        <WeekByWeekSection data-id="element-274" />
        <BonusesSection data-id="element-275" />
        <PreviewSection data-id="element-276" />
        <AuthorSection data-id="element-277" />
        <TestimonialsSection data-id="element-278" />
        <FAQSection data-id="element-279" />
        <OfferStackSection data-id="element-280" />
        <GuaranteeSection data-id="element-281" />
        <FinalCTASection data-id="element-282" />
      </main>

      {/* Footer with extra bottom padding on mobile for sticky CTA */}
      <footer className="bg-text-primary text-white/60 py-8 pb-24 md:pb-8 text-center text-sm" data-id="element-283">
        <div className="max-w-4xl mx-auto px-4" data-id="element-284">
          <p data-id="element-285">© 2026 Conexión Primero. Todos los derechos reservados.</p>

          {/* Legal Links */}
          <div className="flex flex-wrap justify-center gap-3 md:gap-4 mt-4 text-xs" data-id="element-286">
            <button onClick={() => setActiveModal('terminos')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-287">
              Términos y Condiciones
            </button>
            <span className="opacity-40" data-id="element-288">·</span>
            <button onClick={() => setActiveModal('privacidad')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-289">
              Privacidad
            </button>
            <span className="opacity-40" data-id="element-290">·</span>
            <button onClick={() => setActiveModal('cookies')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-291">
              Cookies
            </button>
            <span className="opacity-40" data-id="element-292">·</span>
            <button onClick={() => setActiveModal('reembolsos')} className="underline underline-offset-2 hover:text-white transition-colors" data-id="element-293">
              Reembolsos y Devoluciones
            </button>
          </div>

          <p className="mt-4 text-xs opacity-70" data-id="element-294">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      {/* Legal Modal Overlay */}
      {activeModal && legalContent[activeModal] && <div className="fixed inset-0 z-[100] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-295">
          <div className="bg-white rounded-2xl shadow-xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-296">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-5 md:p-6 border-b border-border flex-shrink-0" data-id="element-297">
              <h3 className="text-lg md:text-xl font-bold text-text-primary font-heading" data-id="element-298">
                {legalContent[activeModal].title}
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-accent transition-colors" aria-label="Cerrar" data-id="element-299">
                <X className="w-5 h-5 text-text-secondary" data-id="element-300" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-5 md:p-6 overflow-y-auto flex-1" data-id="element-301">
              <div className="text-sm md:text-base text-text-secondary leading-relaxed whitespace-pre-line" data-id="element-302">
                {legalContent[activeModal].body}
              </div>
            </div>

            {/* Modal Footer */}
            <div className="p-4 border-t border-border flex-shrink-0" data-id="element-303">
              <button onClick={() => setActiveModal(null)} className="w-full py-2.5 bg-accent hover:bg-border text-text-primary font-medium rounded-xl transition-colors text-sm" data-id="element-304">
                Cerrar
              </button>
            </div>
          </div>
        </div>}

      <StickyCTA data-id="element-305" />
      <PurchasePopup data-id="element-306" />
    </div>;
}